export default "__VITE_ASSET__B_SDIK$r__"